import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetPunchoutApiParameter, getPunchoutList } from "@TKCCP/Services/tkccpPunchoutService";
import { PunchoutServiceCollectionModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandler<GetPunchoutApiParameter, PunchoutServiceCollectionModel>;

export const DispatchBeginLoadPunchouts: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutSecretService/BeginLoadPunchout" as any,
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPunchoutList(props.apiParameter);
};

export const DispatchCompleteLoadPunchouts: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutSecretService/CompleteLoadPunchout" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadPunchouts,
    RequestDataFromApi,
    DispatchCompleteLoadPunchouts,
];

const loadPunchouts = createHandlerChainRunner(chain, "LoadPunchouts");
export default loadPunchouts;
